import type { ToastMessageRef } from "freespace-react-components/components/ToastMessage";
import { createRef } from "react";

// Global ref for ToastMessage component
export const toastRef = createRef<ToastMessageRef>();

type ToastSeverity = "success" | "info" | "warn" | "error";

interface ShowToastOptions {
  severity: ToastSeverity;
  summary?: string;
  detail: string;
  life?: number;
}

export const showToast = (options: ShowToastOptions) => {
  toastRef.current?.showToast(options);
};

export const showErrorToast = (message: string) => {
  showToast({
    severity: "error",
    summary: "Error",
    detail: message,
  });
};

export const showSuccessToast = (message: string) => {
  showToast({
    severity: "success",
    summary: "Success",
    detail: message,
  });
};

export const showInfoToast = (message: string) => {
  showToast({
    severity: "info",
    summary: "Info",
    detail: message,
  });
};

export const showWarningToast = (message: string) => {
  showToast({
    severity: "warn",
    summary: "Warning",
    detail: message,
  });
};

